var exports = {
  "k": "xfd349460--410052--container",
  "K": "xfd349460--410052--icon",
};

module.exports = exports;
